import React, { Suspense } from 'react'
import RdnaModal from '@ringdna/common/src/components/RdnaModal'
import RdnaLoader from '@ringdna/common/src/components/RdnaLoader'

type Props = {
  isModalOpen: boolean
  closeModal: () => void
  clientId: string
  proxy: any // TODO type it
  configId: string
  slug: string
}

const NylasSchedulerEditor = React.lazy(() =>
  import('@nylas/react').then(module => ({ default: module.NylasSchedulerEditor }))
)

export default function EditSchedulingPageModal({ isModalOpen, closeModal, clientId, proxy, configId, slug }: Props) {
  return (
    <RdnaModal open={isModalOpen} onClose={closeModal} maxWidth="lg">
      <Suspense
        fallback={
          <RdnaLoader data loading>
            {null}
          </RdnaLoader>
        }
      >
        <NylasSchedulerEditor
          schedulerPreviewLink={`https://book.nylas.com/us/${clientId}/${slug}`}
          nylasSessionsConfig={{
            clientId: `${clientId}`,
            redirectUri: `${window.location.origin}/scheduler-editor`,
            domain: 'https://api.us.nylas.com/v3',
            hosted: true,
            accessType: 'offline'
          }}
          defaultSchedulerConfigState={{
            selectedConfiguration: {
              requires_session_auth: false
            }
          }}
          configurationId={configId}
          nylasApiRequest={proxy}
        />
        </Suspense>
    </RdnaModal>
  )
}
